<form nz-form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div nz-row [nzGutter]="[16, 16]">
    <div nz-col [nzSpan]="8" *ngFor="let filter of availableFilters">
      <nz-form-item>
        <!-- <nz-form-label>{{ filter.columnName }}</nz-form-label> -->
        <nz-form-control>
          <ng-container [ngSwitch]="filter.type">
            <nz-select
              *ngSwitchCase="1"
              [formControlName]="filter.id"
              [nzPlaceHolder]="filter.columnName"
              [nzLoading]="filterStates[filter.id].loading"
              (nzOnSearch)="onSearch(filter.id, $event)"
              (nzScrollToBottom)="onScrollToBottom(filter.id)"
              nzServerSearch
              nzAllowClear
              nzShowSearch
            >
              <nz-option
                *ngFor="let option of filterStates[filter.id]?.options"
                [nzLabel]="option"
                [nzValue]="option"
              ></nz-option>
              <nz-option *ngIf="filterStates[filter.id]?.loading" nzDisabled>
                <div class="loading-more">Loading more...</div>
              </nz-option>
              <nz-option
                *ngIf="
                  !filterStates[filter.id]?.loading &&
                  filterStates[filter.id]?.options?.length === 0
                "
                nzDisabled
              >
                <div class="no-data">No options found</div>
              </nz-option>
            </nz-select>

            <!-- DateTime -->
            <nz-range-picker
              *ngSwitchCase="2"
              [formControlName]="filter.id"
              [nzPlaceHolder]="['Start ' + filter.columnName, 'End ' + filter.columnName]"
              style="width: 100%"
              nzFormat="yyyy-MM-dd"
            ></nz-range-picker>

            <!-- Number -->
            <input
              *ngSwitchCase="3"
              nz-input
              appOnlyNumbers
              [placeholder]="filter.columnName"
              [formControlName]="filter.id"
              style="width: 100%"
            />

            <!-- String -->
            <input
              *ngSwitchCase="4"
              nz-input
              [placeholder]="filter.columnName"
              [formControlName]="filter.id"
              [placeholder]="'Enter ' + filter.columnName"
            />

            <!-- CheckBox -->
            <nz-checkbox *ngSwitchCase="5" [formControlName]="filter.id"></nz-checkbox>

            <!-- MultiSelect -->
            <nz-select
              *ngSwitchCase="6"
              [formControlName]="filter.id"
              nzPlaceHolder="Select options"
              [nzLoading]="filterStates[filter.id].loading"
              (nzOnSearch)="onSearch(filter.id, $event)"
              (nzScrollToBottom)="onScrollToBottom(filter.id)"
              [nzPlaceHolder]="filter.columnName"
              nzMode="multiple"
              nzServerSearch
              nzShowSearch
            >
              <nz-option
                *ngFor="let option of filterStates[filter.id]?.options"
                [nzLabel]="option"
                [nzValue]="option"
              ></nz-option>
              <nz-option *ngIf="filterStates[filter.id]?.loading" nzDisabled>
                <div class="loading-more">Loading more...</div>
              </nz-option>
              <nz-option
                *ngIf="
                  !filterStates[filter.id]?.loading &&
                  filterStates[filter.id]?.options?.length === 0
                "
                nzDisabled
              >
                <div class="no-data">No options found</div>
              </nz-option>
            </nz-select>

            <!-- None Type -->
            <div *ngSwitchCase="0" class="none-type">No filter required for this field</div>
          </ng-container>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>

  <!-- Only show buttons if there are available filters -->
  <div class="submit-section" *ngIf="availableFilters && availableFilters.length > 0">
    <button (click)="resetFilters()" nz-button nzSize="large" type="button">Reset Filters</button>
    <button nz-button nzType="primary" nzSize="large" type="submit">Apply Filters</button>
  </div>
</form>
